import React, { useState, useEffect, useContext, useCallback } from "react";
import {
  Row,
  Col,
  Card,
  Avatar,
  Form,
  Button,
  Input,
  Tag,
  Typography,
  Progress,
  Table,
  Modal,
  Select,
  Spin,
  Switch,
  Tooltip,
  Skeleton,
} from "antd";
import { CustomTitle, CustomSubTitle } from "../physician_page/styled";
import { physicianService } from "../../../services/user";
import { PersonalInfoWrapper, ProfilePageWrapper } from "./styled";
import { capitalizeFirstLetter } from "../../../utils/utils";
import { BiSolidPencil } from "react-icons/bi";
import {
  PlusOutlined,
  DeleteOutlined,
  UploadOutlined,
  FileExcelOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import moment from "moment";
import moment_ori from "moment";
import { checkStrongPassword, limitedcountry, validateZipCode } from "../../../utils/utils";
import {
  EyeOutlined,
  EyeInvisibleOutlined,
  CheckOutlined,
  CloseOutlined,
  SafetyOutlined,
  LoadingOutlined
} from "@ant-design/icons";
import { CustomButton, CustomSecondaryButton } from "../physician_page/styled";
import auth from "../../../services/auth";
import { notify } from "../../../utils/helper";
import styled from "styled-components";
// import { specialtyOptions } from "../../../utils/utils";
import ModalWrapper from "../../modal/ModelWrapper";
import cptCodesService from "../../../services/cpt_codes";
import specialtyService from "../../../services/specility";
import DeleteConfirmationModal from "../physician_page/component/DeleteConfirmationModal";
import { EditOutlined } from "@ant-design/icons";
import { Upload, Tabs, Divider, Space, Popconfirm } from "antd";
import { decyprtData } from "../../../utils/axios";
import { CustomSearchContainer } from "../../table-item";
import { CiSearch } from "react-icons/ci";
import { SpecilityContext } from "../../../context/SpecilityContext";
import { extractToken } from "../../../utils/localStorage";
import { globalRoles } from "../../../utils/roles";
import { StyledTable } from "../admin/videos/styled";
import { debounce } from "../../../utils/helper"
import icdCodesService from "../../../services/icd_codes";

const { Title, Text, Paragraph } = Typography;
const { Option } = Select;


export const FileUploadContainer = styled.div`
  .ant-upload.ant-upload-drag {
    background: var(--primary-bg);
    border: 2px dashed var(--border-color);
    border-radius: 8px;
    padding: 20px;
    text-align: center;
    transition: border-color 0.3s;

    &:hover {
      border-color: rgba(138, 62, 244, 0.7);
    }
  }

  .upload-icon {
    font-size: 48px;
    color: #d9d9d9;
    margin-bottom: 16px;
  }

  .upload-text {
    font-size: 16px;
    color: #666;
    margin-bottom: 8px;
  }

  .upload-hint {
    font-size: 14px;
    color: var(--secondary-text-color) !important;
  }
  .ant-upload-list-item {
    background-color: var(--border-color);
    border-radius: 2px;
  }
  .ant-upload-list-item:hover  .ant-upload-list-item-info {
    background-color: var(--border-color) !important;
  }
  .anticon{
    color: color: var(--primary-text-color);;
  }
  .ant-upload-list, .ant-upload-list-item-info .ant-upload-text-icon .anticon {
    color: var(--primary-text-color);
  }
  .ant-upload-list-item-card-actions:hover .anticon {
    color: var(--primary-text-color) !important;
  }
`;

export const SpinWrapper = styled.div`
  .ant-spin-dot-item {
    background-color: #fff;
  }
`;

const FormContainer = styled.div`
  max-height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 10px;
  width: 100%;

  /* Scrollbar styling */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`;

const SectionContainer = styled.div`
  opacity: ${(props) => (props.show ? 1 : 0)};
  transform: translateY(${(props) => (props.show ? "0" : "10px")});
  transition: all 0.3s ease-in-out;
  pointer-events: ${(props) => (props.show ? "auto" : "none")};
  position: ${(props) => (props.show ? "relative" : "absolute")};
  width: 100%;

  ${(props) =>
    !props.show &&
    `
    height: 0;
    overflow: hidden;
  `}
`;

const IndividualSection = styled.div`
  padding: 24px;
  background: var(--primary-bg);
  border-radius: 8px;
  border: 1px solid var(--border-color);

  .section-title {
    font-size: 16px;
    font-weight: 500;
    color: var(--primary-text-color);
    margin-bottom: 10px;
    padding-bottom: 8px;
    border-bottom: 1px solid var(--border-color);
  }

  .ant-input,
  .ant-select-selector {
    border-radius: 6px;
    transition: all 0.3s;

    &:hover {
      border-color: rgba(138, 62, 244, 0.5);
    }

    &:focus,
    &.ant-select-focused .ant-select-selector {
      border-color: rgba(138, 62, 244, 0.7);
      box-shadow: 0 0 0 2px rgba(138, 62, 244, 0.1);
    }
  }
`;

const ToggleContainer = styled.div`
  margin-bottom: 24px;
  padding: 16px;
  background: var(--primary-bg);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--border-color);

  .ant-switch-inner {
    display: block;
    margin: 0px 28px 0px 25px;
    color: var(--primary-text-color);
    font-size: 12px;
    transition: margin 0.2s;
    font-weight: 700;
    font-family: "Inter", sans-serif;
  }

  .toggle-label {
    display: flex;
    align-items: center;
    gap: 8px;

    .ant-typography {
      margin: 0;
      font-weight: 500;
      color: var(--primary-text-color);
    }
  }
  .ant-switch-checked {
    background-color: rgba(138, 62, 244, 0.7) !important;
  }
  .ant-switch:focus {
    box-shadow: none;
  }
`;

const GroupSection = styled.div`
  margin-top: 16px;
  padding: 20px;
  background: var(--primary-bg);
  border-radius: 8px;
  border: 1px solid var(--border-color);

  .ant-form-item-extra {
    color: var(--secondary-text-color);
  }
`;

const SampleFileContainer = styled.div`
  background: var(--border-color);
  border: 1px solid var(--border-color);
  border-radius: 6px;
  padding: 12px 16px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .sample-text {
    color: var(--primary-text-color);
    font-size: 13px;
    margin: 0;
  }

  .download-link {
    color: #1890ff;
    font-size: 13px;
    cursor: pointer;
    text-decoration: underline;
    display: flex;
    align-items: center;
    gap: 4px;

    &:hover {
      color: #40a9ff;
    }
  }
`;

// Edit CPT Code Modal Component
const EditCPTModal = ({ visible, setVisible, onClose, onSuccess, cptData }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { specialtyOptions } = useContext(SpecilityContext);

  useEffect(() => {
    if (visible && cptData) {
      form.setFieldsValue({
        code: cptData.code,
        // specialty: cptData.specialty,
        description: cptData.description,
      });
    }
  }, [visible, cptData, form]);

  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      await cptCodesService.updateCptCodes(cptData.id, values);
      notify("success", "CPT code updated successfully!");
      form.resetFields();
      setLoading(false);
      onSuccess();
      onClose();
    } catch (error) {
      notify("error", "Error updating CPT code.");
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <ModalWrapper
      title="Edit CPT Code"
      show={visible}
      setShow={setVisible}
      onCancel={handleCancel}
      footer={null}
      width={600}
      destroyOnClose
    >
      <Spin spinning={loading}>
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Form.Item
                name="code"
                label="CPT Code"
                rules={[
                  { required: true, message: "Please input the CPT code!" },
                ]}
              >
                <Input placeholder="Enter CPT Code" />
              </Form.Item>
            </Col>

            {/* <Col span={24}>
              <Form.Item
                name="specialty"
                label="Specialty"
                rules={[
                  { required: true, message: "Please select a specialty!" },
                ]}
              >
                <Select
                  placeholder="Select Specialty"
                  showSearch
                  style={{ width: "100%" }}
                  options={specialtyOptions}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                />
              </Form.Item>
            </Col> */}

            <Col span={24}>
              <Form.Item
                name="description"
                label="Description"
                rules={[
                  { required: true, message: "Please input description!" },
                ]}
              >
                <Input.TextArea placeholder="Enter Description" rows={3} />
              </Form.Item>
            </Col>
          </Row>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "12px",
              marginTop: "20px",
            }}
          >
            <Button style={{color: "var(--primary-text-color)"}} onClick={handleCancel}>Cancel</Button>
            <CustomButton htmlType="submit" loading={loading}>
              {loading ? "Updating..." : "Update CPT Code"}
            </CustomButton>
          </div>
        </Form>
      </Spin>
    </ModalWrapper>
  );
};

// CPT Codes Modal Component
const AddCPTModal = ({ visible, setVisible, onClose, onSuccess }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [cptForms, setCptForms] = useState(
    Array.from({ length: 10 }, (_, i) => ({ id: i + 1 }))
  );
  const [activeTab, setActiveTab] = useState("individual");
  const [fileList, setFileList] = useState([]);
  const { specialtyOptions } = useContext(SpecilityContext);
  // File upload states
  const [uploadedFile, setUploadedFile] = useState(null);
  const [previewData, setPreviewData] = useState([]);
  const [fileLoading, setFileLoading] = useState(false);
  const [editingRow, setEditingRow] = useState(null);
  const [isPreviewMode, setIsPreviewMode] = useState(false);
  const [showUploadInGroup, setShowUploadInGroup] = useState(false);

  // Function to download sample CSV file
  const downloadSampleFile = () => {
    const link = document.createElement("a");
    link.href = "/code.xlsx";
    link.setAttribute("download", "code.xlsx");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleFileChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };

  const uploadProps = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      setFileList([...fileList, file]);
      return false;
    },
    fileList,
  };

  const createCPTCode = async (values) => {
    try {
      setLoading(true);

      if (activeTab === "individual") {
        // Manual entry
        const cptCodesToCreate = cptForms
          .map((cpt) => ({
            code: values[`cpt_${cpt.id}_code`],
            // specialty: values[`cpt_${cpt.id}_specialty`],
            description: values[`cpt_${cpt.id}_description`],
          }))
          .filter((c) => c.code && c.description);

        if (cptCodesToCreate.length === 0) {
          notify(
            "error",
            "Please fill in all required fields for at least one CPT code."
          );
          setLoading(false);
          return;
        }

        await cptCodesService.createCptCodes(cptCodesToCreate);
        notify(
          "success",
          `${cptCodesToCreate.length} CPT codes created successfully.`
        );
      } else {
        // File upload handling
        if (values.cptFile && !isPreviewMode) {
          // First step: Preview the file
          const formData = new FormData();
          formData.append("file", values.cptFile.file);
          const response = await cptCodesService.previewImport(formData);
          const previewCPTCodes = decyprtData(response?.data);

          // Set preview data and enter preview mode
          setPreviewData(
            previewCPTCodes?.map((cpt, index) => ({
              ...cpt,
              id: index + 1,
              alreadyExists: cpt.alreadyExists || false,
            })) || []
          );
          setIsPreviewMode(true);
          setLoading(false);
          notify(
            "info",
            "File preview loaded. Please review and fix any duplicates before uploading."
          );
          return; // Don't close modal, stay in preview mode
        } else if (isPreviewMode) {
          // Second step: Actual upload after review
          const validCPTCodes = previewData.filter(
            (c) => c.code && c.description
          );

          if (validCPTCodes.length === 0) {
            notify(
              "error",
              "Please ensure at least one CPT code has valid data (code, specialty, and description)."
            );
            setLoading(false);
            return;
          }

          // Send the modified preview data in the same structure as received
          const uploadPayload = validCPTCodes.map(
            ({ id, alreadyExists, ...cpt }) => ({
              code: cpt.code,
              // specialty: cpt.specialty,
              description: cpt.description,
            })
          );


          await cptCodesService.createCptCodes(uploadPayload);
          notify(
            "success",
            `${validCPTCodes.length} CPT codes uploaded successfully!`
          );
        } else {
          notify("error", "Please upload a file or fill manual entries.");
          setLoading(false);
          return;
        }
      }

      handleCancel();
    } catch (error) {
      console.error("Error creating CPT code(s):", error);
      notify("error", error?.data?.message || "Error creating CPT code(s).");
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    setCptForms(Array.from({ length: 10 }, (_, i) => ({ id: i + 1 })));
    setUploadedFile(null);
    setVisible(false);
    setPreviewData([]);
    setActiveTab("individual");
    setEditingRow(null);
    setIsPreviewMode(false);
    setShowUploadInGroup(false);
    setFileList([]);
    setLoading(false);

    onSuccess();
    onClose();
  };

  return (
    <ModalWrapper
      title="Add CPT Codes"
      show={visible}
      setShow={setVisible}
      onCancel={handleCancel}
      footer={null}
      width={900}
      destroyOnClose
    >
      <Spin spinning={loading}>
        <Form
          form={form}
          layout="vertical"
          onFinish={createCPTCode}
          loading={loading}
        >
          <FormContainer>
            <ToggleContainer>
              <div className="toggle-label">
                <Typography.Text>Individual</Typography.Text>
                <Switch
                  checked={activeTab === "file-upload"}
                  onChange={(checked) =>
                    setActiveTab(checked ? "file-upload" : "individual")
                  }
                  checkedChildren="File Upload"
                  unCheckedChildren="Individual"
                />
                <Typography.Text>File Upload</Typography.Text>
              </div>
            </ToggleContainer>

            <SectionContainer show={activeTab === "individual"}>
              <IndividualSection>
                <div
                  className="section-title font-16 text-primary"
                  style={{ fontWeight: 600 }}
                >
                  CPT Code Information
                </div>

                {/* Individual CPT Code Forms - Row Style */}
                <div style={{ marginBottom: "20px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                      marginBottom: "8px",
                    }}
                  >
                    <div>
                      <Typography.Text
                        strong
                        style={{
                          color: "var(--primary-text-color)",
                          marginBottom: "8px",
                          display: "block",
                        }}
                      >
                        Add CPT Codes (Up to 10 CPT Codes)
                      </Typography.Text>
                      <Typography.Text
                        style={{
                          color: "var(--secondary-text-color)",
                          marginBottom: "16px",
                          display: "block",
                          fontSize: "13px",
                        }}
                      >
                        Fill at least one complete CPT code. If you start
                        filling a row, all fields in that row become required.
                      </Typography.Text>
                    </div>
                  </div>

                  {/* Sticky Header */}
                  <div
                    style={{
                      position: "sticky",
                      top: "0",
                      zIndex: 10,
                      background: "var(--secondary-bg)",
                      border: "1px solid var(--border-color)",
                      borderRadius: "4px 4px 0 0",
                      padding: "8px",
                      marginBottom: "0",
                    }}
                  >
                    <Row gutter={[8, 0]} align="middle">
                      <Col span={1}>
                        <div
                          style={{
                            fontSize: "13px",
                            fontWeight: "600",
                            color: "var(--primary-text-color)",
                            textAlign: "center",
                          }}
                        >
                          #
                        </div>
                      </Col>
                      <Col span={8}>
                        <div
                          style={{
                            fontSize: "13px",
                            fontWeight: "600",
                            color: "var(--primary-text-color)",
                          }}
                        >
                          CPT Code
                        </div>
                      </Col>
                      {/* <Col span={8}>
                        <div
                          style={{
                            fontSize: "13px",
                            fontWeight: "600",
                            color: "var(--primary-text-color)",
                          }}
                        >
                          Specialty
                        </div>
                      </Col> */}
                      <Col span={12}>
                        <div
                          style={{
                            fontSize: "13px",
                            fontWeight: "600",
                            color: "var(--primary-text-color)",
                          }}
                        >
                          Description
                        </div>
                      </Col>
                    </Row>
                  </div>

                  {/* Scrollable Rows */}
                  <div
                    style={{
                      maxHeight: "400px",
                      overflowY: "auto",
                      border: "1px solid var(--border-color)",
                      borderTop: "none",
                      borderRadius: "0 0 4px 4px",
                    }}
                  >
                    {cptForms.map((cpt, index) => (
                      <div
                        key={cpt.id}
                        style={{
                          padding: "8px",
                          borderBottom:
                            index < cptForms.length - 1
                              ? "1px solid var(--border-color)"
                              : "none",
                          background: "var(--primary-bg)",
                          "&:hover": { background: "var(--secondary-bg)" },
                        }}
                      >
                        <Row gutter={[8, 0]} align="middle">
                          <Col span={1}>
                            <div
                              style={{
                                fontSize: "13px",
                                fontWeight: "500",
                                color: "var(--secondary-text-color)",
                                textAlign: "center",
                              }}
                            >
                              {index + 1}
                            </div>
                          </Col>

                          <Col span={8}>
                            <Form.Item
                              name={`cpt_${cpt.id}_code`}
                              rules={[
                                ({ getFieldValue }) => ({
                                  validator(_, value) {
                                    if (activeTab !== "individual") {
                                      return Promise.resolve();
                                    }

                                    const specialty = getFieldValue(
                                      `cpt_${cpt.id}_specialty`
                                    );
                                    const description = getFieldValue(
                                      `cpt_${cpt.id}_description`
                                    );

                                    // If any field is filled, all fields are required for this CPT
                                    if (specialty || description) {
                                      if (!value) {
                                        return Promise.reject(
                                          new Error(
                                            "CPT Code is required when specialty or description is provided!"
                                          )
                                        );
                                      }
                                    }

                                    // If this is the first CPT and no other CPTs are filled, require at least this one
                                    if (cpt.id === 1) {
                                      const allValues = form.getFieldsValue();
                                      const hasAnyOtherCPT = cptForms
                                        .slice(1)
                                        .some(
                                          (c) =>
                                            allValues[`cpt_${c.id}_code`] ||
                                            allValues[
                                              `cpt_${c.id}_specialty`
                                            ] ||
                                            allValues[`cpt_${c.id}_description`]
                                        );

                                      if (
                                        !hasAnyOtherCPT &&
                                        !value &&
                                        !specialty &&
                                        !description
                                      ) {
                                        return Promise.reject(
                                          new Error(
                                            "At least one CPT code is required!"
                                          )
                                        );
                                      }
                                    }

                                    return Promise.resolve();
                                  },
                                }),
                              ]}
                              style={{ marginBottom: "0" }}
                            >
                              <Input
                                placeholder="Enter CPT Code"
                                size="small"
                              />
                            </Form.Item>
                          </Col>

                          {/* <Col span={8}>
                            <Form.Item
                              name={`cpt_${cpt.id}_specialty`}
                              rules={[
                                ({ getFieldValue }) => ({
                                  validator(_, value) {
                                    if (activeTab !== "individual") {
                                      return Promise.resolve();
                                    }

                                    const code = getFieldValue(
                                      `cpt_${cpt.id}_code`
                                    );
                                    const description = getFieldValue(
                                      `cpt_${cpt.id}_description`
                                    );

                                    // If any field is filled, all fields are required for this CPT
                                    if (code || description) {
                                      if (!value) {
                                        return Promise.reject(
                                          new Error(
                                            "Specialty is required when code or description is provided!"
                                          )
                                        );
                                      }
                                    }

                                    return Promise.resolve();
                                  },
                                }),
                              ]}
                              style={{ marginBottom: "0" }}
                            >
                              <Select
                                getPopupContainer={(triggerNode) =>
                                  triggerNode.parentNode
                                }
                                placeholder="Select Specialty"
                                showSearch
                                size="small"
                                style={{ width: "100%" }}
                                dropdownStyle={{
                                  maxHeight: 200,
                                  overflowY: "auto",
                                  overflowX: "hidden",
                                }}
                                listHeight={160}
                                options={specialtyOptions}
                                loading={loading}
                                filterOption={(input, option) =>
                                  (option?.label ?? "")
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                              />
                            </Form.Item>
                          </Col> */}

                          <Col span={14}>
                            <Form.Item
                              name={`cpt_${cpt.id}_description`}
                              rules={[
                                ({ getFieldValue }) => ({
                                  validator(_, value) {
                                    if (activeTab !== "individual") {
                                      return Promise.resolve();
                                    }

                                    const code = getFieldValue(
                                      `cpt_${cpt.id}_code`
                                    );
                                    const specialty = getFieldValue(
                                      `cpt_${cpt.id}_specialty`
                                    );

                                    // If any field is filled, all fields are required for this CPT
                                    if (code || specialty) {
                                      if (!value) {
                                        return Promise.reject(
                                          new Error(
                                            "Description is required when code or specialty is provided!"
                                          )
                                        );
                                      }
                                    }

                                    return Promise.resolve();
                                  },
                                }),
                              ]}
                              style={{ marginBottom: "0" }}
                            >
                              <Input
                                placeholder="Enter Description"
                                size="small"
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      </div>
                    ))}
                  </div>
                </div>
              </IndividualSection>
            </SectionContainer>

            <SectionContainer show={activeTab === "file-upload"}>
              <GroupSection>
                {/* File Upload Section */}
                <div style={{ marginBottom: "20px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                      marginBottom: "8px",
                    }}
                  >
                    <div>
                      <Typography.Text
                        strong
                        style={{
                          color: "var(--primary-text-color)",
                          marginBottom: "8px",
                          display: "block",
                        }}
                      >
                        Upload CPT Codes File
                      </Typography.Text>
                      <Typography.Text
                        style={{
                          color: "var(--secondary-text-color)",
                          marginBottom: "16px",
                          display: "block",
                          fontSize: "13px",
                        }}
                      >
                        {isPreviewMode
                          ? "Review the data below. CPT codes with red background already exist - please update their code or remove them."
                          : "Upload a CSV or Excel file containing CPT code details for bulk creation."}
                      </Typography.Text>
                    </div>
                  </div>

                  {!isPreviewMode && (
                    <>
                      <SampleFileContainer>
                        <Typography.Text className="sample-text">
                          Download our sample template to get started.
                        </Typography.Text>
                        <span
                          className="download-link"
                          onClick={downloadSampleFile}
                        >
                          <DownloadOutlined />
                          Download Sample
                        </span>
                      </SampleFileContainer>

                      <Row gutter={[24, 16]}>
                        <Col span={24}>
                          <Form.Item
                            name="cptFile"
                            label="Upload CPT Code Details"
                            extra="Supported formats: CSV, XLSX, XLS. Maximum file size: 10MB."
                          >
                            <Upload {...uploadProps} accept=".csv,.xlsx,.xls">
                              <Button
                                icon={<UploadOutlined />}
                                size="large"
                                block
                                className="text-primary"
                              >
                                Click to Upload File
                              </Button>
                            </Upload>
                          </Form.Item>
                        </Col>
                      </Row>
                    </>
                  )}

                  {isPreviewMode && previewData.length > 0 && (
                    <div style={{ marginBottom: "20px" }}>
                      {/* Sticky Header */}
                      <div
                        style={{
                          position: "sticky",
                          top: "0",
                          zIndex: 10,
                          background: "var(--secondary-bg)",
                          border: "1px solid var(--border-color)",
                          borderRadius: "4px 4px 0 0",
                          padding: "8px",
                          marginBottom: "0",
                        }}
                      >
                        <Row gutter={[8, 0]} align="middle">
                          <Col span={1}>
                            <div
                              style={{
                                fontSize: "13px",
                                fontWeight: "600",
                                color: "var(--primary-text-color)",
                                textAlign: "center",
                              }}
                            >
                              #
                            </div>
                          </Col>
                          <Col span={8}>
                            <div
                              style={{
                                fontSize: "13px",
                                fontWeight: "600",
                                color: "var(--primary-text-color)",
                              }}
                            >
                              CPT Code
                            </div>
                          </Col>
                          {/* <Col span={8}>
                            <div
                              style={{
                                fontSize: "13px",
                                fontWeight: "600",
                                color: "var(--primary-text-color)",
                              }}
                            >
                              Specialty
                            </div>
                          </Col> */}
                          <Col span={14}>
                            <div
                              style={{
                                fontSize: "13px",
                                fontWeight: "600",
                                color: "var(--primary-text-color)",
                              }}
                            >
                              Description
                            </div>
                          </Col>
                          <Col span={1}>
                            <div
                              style={{
                                fontSize: "13px",
                                fontWeight: "600",
                                color: "var(--primary-text-color)",
                                textAlign: "center",
                              }}
                            ></div>
                          </Col>
                        </Row>
                      </div>

                      {/* Preview Data Rows */}
                      <div
                        style={{
                          maxHeight: "400px",
                          overflowY: "auto",
                          border: "1px solid var(--border-color)",
                          borderTop: "none",
                          borderRadius: "0 0 4px 4px",
                        }}
                      >
                        {previewData.map((cpt, index) => (
                          <div
                            key={cpt.id}
                            style={{
                              padding: "8px",
                              borderBottom:
                                index < previewData.length - 1
                                  ? "1px solid var(--border-color)"
                                  : "none",
                              background: cpt.alreadyExists
                                ? "#fee"
                                : "var(--primary-bg)",
                              "&:hover": {
                                background: cpt.alreadyExists
                                  ? "#fdd"
                                  : "var(--secondary-bg)",
                              },
                            }}
                          >
                            <Row gutter={[8, 0]} align="middle">
                              <Col span={1}>
                                <div
                                  style={{
                                    fontSize: "13px",
                                    fontWeight: "500",
                                    color: "var(--secondary-text-color)",
                                    textAlign: "center",
                                  }}
                                >
                                  {index + 1}
                                </div>
                              </Col>

                              <Col span={8}>
                                <Input
                                  size="small"
                                  value={cpt.code}
                                  onChange={(e) => {
                                    const newData = [...previewData];
                                    newData[index].code = e.target.value;
                                    newData[index].alreadyExists = false; // Reset exists status when code changes
                                    setPreviewData(newData);
                                  }}
                                  style={{
                                    border: cpt.alreadyExists
                                      ? "1px solid #ff4d4f"
                                      : "1px solid var(--border-color)",
                                  }}
                                />
                              </Col>

                              {/* <Col span={8}>
                                <Select
                                  size="small"
                                  value={cpt.specialty}
                                  onChange={(value) => {
                                    const newData = [...previewData];
                                    newData[index].specialty = value;
                                    setPreviewData(newData);
                                  }}
                                  style={{ width: "100%" }}
                                  options={specialtyOptions}
                                  showSearch
                                  filterOption={(input, option) =>
                                    (option?.label ?? "")
                                      .toLowerCase()
                                      .includes(input.toLowerCase())
                                  }
                                />
                              </Col> */}

                              <Col span={14}>
                                <Input
                                  size="small"
                                  value={cpt.description}
                                  onChange={(e) => {
                                    const newData = [...previewData];
                                    newData[index].description = e.target.value;
                                    newData[index].alreadyExists = false; // Reset exists status when description changes
                                    setPreviewData(newData);
                                  }}
                                  style={{
                                    border: cpt.alreadyExists
                                      ? "1px solid #ff4d4f"
                                      : "1px solid var(--border-color)",
                                  }}
                                />
                              </Col>

                              <Col span={1}>
                                <div
                                  onClick={() => {
                                    const newData = previewData.filter(
                                      (_, i) => i !== index
                                    );
                                    setPreviewData(newData);
                                  }}
                                  style={{
                                    color: "#ff4d4f",
                                    cursor: "pointer",
                                    fontSize: "16px",
                                  }}
                                >
                                  <DeleteOutlined />
                                </div>
                              </Col>
                            </Row>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </GroupSection>
            </SectionContainer>
          </FormContainer>

          <Divider style={{ margin: "20px 0" }} />

          <Row>
            <Col span={24} className="d-flex justify-end gap-12">
              {isPreviewMode && (
                <CustomSecondaryButton
                  onClick={() => {
                    setIsPreviewMode(false);
                    setPreviewData([]);
                    setFileList([]);
                  }}
                >
                  Back to Upload
                </CustomSecondaryButton>
              )}
              <CustomSecondaryButton onClick={handleCancel}>
                Cancel
              </CustomSecondaryButton>
              <CustomButton htmlType="submit" loading={loading}>
                {loading
                  ? "Processing..."
                  : isPreviewMode
                  ? "Upload CPT Codes"
                  : "Add CPT Codes"}
              </CustomButton>
            </Col>
          </Row>
        </Form>
      </Spin>
    </ModalWrapper>
  );
};

// ICD Codes Modal Component
const AddICDModal = ({ visible, setVisible, onClose, onSuccess }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [icdForms, setIcdForms] = useState(
    Array.from({ length: 10 }, (_, i) => ({ id: i + 1 }))
  );
  const [activeTab, setActiveTab] = useState("individual");
  const [fileList, setFileList] = useState([]);
  const { specialtyOptions } = useContext(SpecilityContext);
  // File upload states
  const [uploadedFile, setUploadedFile] = useState(null);
  const [previewData, setPreviewData] = useState([]);
  const [fileLoading, setFileLoading] = useState(false);
  const [editingRow, setEditingRow] = useState(null);
  const [isPreviewMode, setIsPreviewMode] = useState(false);
  const [showUploadInGroup, setShowUploadInGroup] = useState(false);

  // Function to download sample CSV file
  const downloadSampleFile = () => {
    const link = document.createElement("a");
    link.href = "/code.xlsx";
    link.setAttribute("download", "code.xlsx");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleFileChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };

  const uploadProps = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      setFileList([...fileList, file]);
      return false;
    },
    fileList,
  };

  const createICDCode = async (values) => {
    try {
      setLoading(true);

      if (activeTab === "individual") {
        // Manual entry
        const icdCodesToCreate = icdForms
          .map((icd) => ({
            code: values[`icd_${icd.id}_code`],
            // specialty: values[`icd_${icd.id}_specialty`],
            description: values[`icd_${icd.id}_description`],
          }))
          .filter((c) => c.code && c.description);

        if (icdCodesToCreate.length === 0) {
          notify(
            "error",
            "Please fill in all required fields for at least one ICD code."
          );
          setLoading(false);
          return;
        }

        await icdCodesService.createIcdCodes(icdCodesToCreate);
        notify(
          "success",
          `${icdCodesToCreate.length} ICD codes created successfully.`
        );
      } else {
        // File upload handling
        if (values.icdFile && !isPreviewMode) {
          // First step: Preview the file
          const formData = new FormData();
          formData.append("file", values.icdFile.file);
          const response = await icdCodesService.previewImportIcdCodes(formData);
          const previewICDCodes = decyprtData(response?.data);

          // Set preview data and enter preview mode
          setPreviewData(
            previewICDCodes?.map((icd, index) => ({
              ...icd,
              id: index + 1,
              alreadyExists: icd.alreadyExists || false,
            })) || []
          );
          setIsPreviewMode(true);
          setLoading(false);
          notify(
            "info",
            "File preview loaded. Please review and fix any duplicates before uploading."
          );
          return; // Don't close modal, stay in preview mode
        } else if (isPreviewMode) {
          // Second step: Actual upload after review
          const validICDCodes = previewData.filter(
            (c) => c.code && c.description
          );

          if (validICDCodes.length === 0) {
            notify(
              "error",
              "Please ensure at least one ICD code has valid data (code, and description)."
            );
            setLoading(false);
            return;
          }

          // Send the modified preview data in the same structure as received
          const uploadPayload = validICDCodes.map(
            ({ id, alreadyExists, ...icd }) => ({
              code: icd.code,
              // specialty: icd.specialty,
              description: icd.description,
            })
          );


          await icdCodesService.createIcdCodes(uploadPayload);
          notify(
            "success",
            `${validICDCodes.length} ICD codes uploaded successfully!`
          );
        } else {
          notify("error", "Please upload a file or fill manual entries.");
          setLoading(false);
          return;
        }
      }

      handleCancel();
    } catch (error) {
      console.error("Error creating ICD code(s):", error);
      notify("error", error?.data?.message || "Error creating ICD code(s).");
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    setIcdForms(Array.from({ length: 10 }, (_, i) => ({ id: i + 1 })));
    setUploadedFile(null);
    setVisible(false);
    setPreviewData([]);
    setActiveTab("individual");
    setEditingRow(null);
    setIsPreviewMode(false);
    setShowUploadInGroup(false);
    setFileList([]);
    setLoading(false);

    onSuccess();
    onClose();
  };

  return (
    <ModalWrapper
      title="Add ICD Codes"
      show={visible}
      setShow={setVisible}
      onCancel={handleCancel}
      footer={null}
      width={900}
      destroyOnClose
    >
      <Spin spinning={loading}>
        <Form
          form={form}
          layout="vertical"
          onFinish={createICDCode}
          loading={loading}
        >
          <FormContainer>
            <ToggleContainer>
              <div className="toggle-label">
                <Typography.Text>Individual</Typography.Text>
                <Switch
                  checked={activeTab === "file-upload"}
                  onChange={(checked) =>
                    setActiveTab(checked ? "file-upload" : "individual")
                  }
                  checkedChildren="File Upload"
                  unCheckedChildren="Individual"
                />
                <Typography.Text>File Upload</Typography.Text>
              </div>
            </ToggleContainer>

            <SectionContainer show={activeTab === "individual"}>
              <IndividualSection>
                <div
                  className="section-title font-16 text-primary"
                  style={{ fontWeight: 600 }}
                >
                  ICD Code Information
                </div>

                {/* Individual ICD Code Forms - Row Style */}
                <div style={{ marginBottom: "20px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                      marginBottom: "8px",
                    }}
                  >
                    <div>
                      <Typography.Text
                        strong
                        style={{
                          color: "var(--primary-text-color)",
                          marginBottom: "8px",
                          display: "block",
                        }}
                      >
                        Add ICD Codes (Up to 10 ICD Codes)
                      </Typography.Text>
                      <Typography.Text
                        style={{
                          color: "var(--secondary-text-color)",
                          marginBottom: "16px",
                          display: "block",
                          fontSize: "13px",
                        }}
                      >
                        Fill at least one complete ICD code. If you start
                        filling a row, all fields in that row become required.
                      </Typography.Text>
                    </div>
                  </div>

                  {/* Sticky Header */}
                  <div
                    style={{
                      position: "sticky",
                      top: "0",
                      zIndex: 10,
                      background: "var(--secondary-bg)",
                      border: "1px solid var(--border-color)",
                      borderRadius: "4px 4px 0 0",
                      padding: "8px",
                      marginBottom: "0",
                    }}
                  >
                    <Row gutter={[8, 0]} align="middle">
                      <Col span={1}>
                        <div
                          style={{
                            fontSize: "13px",
                            fontWeight: "600",
                            color: "var(--primary-text-color)",
                            textAlign: "center",
                          }}
                        >
                          #
                        </div>
                      </Col>
                      <Col span={8}>
                        <div
                          style={{
                            fontSize: "13px",
                            fontWeight: "600",
                            color: "var(--primary-text-color)",
                          }}
                        >
                          ICD Code
                        </div>
                      </Col>
                      {/* <Col span={8}>
                        <div
                          style={{
                            fontSize: "13px",
                            fontWeight: "600",
                            color: "var(--primary-text-color)",
                          }}
                        >
                          Specialty
                        </div>
                      </Col> */}
                      <Col span={12}>
                        <div
                          style={{
                            fontSize: "13px",
                            fontWeight: "600",
                            color: "var(--primary-text-color)",
                          }}
                        >
                          Description
                        </div>
                      </Col>
                    </Row>
                  </div>

                  {/* Scrollable Rows */}
                  <div
                    style={{
                      maxHeight: "400px",
                      overflowY: "auto",
                      border: "1px solid var(--border-color)",
                      borderTop: "none",
                      borderRadius: "0 0 4px 4px",
                    }}
                  >
                    {icdForms.map((icd, index) => (
                      <div
                        key={icd.id}
                        style={{
                          padding: "8px",
                          borderBottom:
                            index < icdForms.length - 1
                              ? "1px solid var(--border-color)"
                              : "none",
                          background: "var(--primary-bg)",
                          "&:hover": { background: "var(--secondary-bg)" },
                        }}
                      >
                        <Row gutter={[8, 0]} align="middle">
                          <Col span={1}>
                            <div
                              style={{
                                fontSize: "13px",
                                fontWeight: "500",
                                color: "var(--secondary-text-color)",
                                textAlign: "center",
                              }}
                            >
                              {index + 1}
                            </div>
                          </Col>

                          <Col span={8}>
                            <Form.Item
                              name={`icd_${icd.id}_code`}
                              rules={[
                                ({ getFieldValue }) => ({
                                  validator(_, value) {
                                    if (activeTab !== "individual") {
                                      return Promise.resolve();
                                    }

                                    const specialty = getFieldValue(
                                      `icd_${icd.id}_specialty`
                                    );
                                    const description = getFieldValue(
                                      `icd_${icd.id}_description`
                                    );

                                    // If any field is filled, all fields are required for this ICD
                                    if (specialty || description) {
                                      if (!value) {
                                        return Promise.reject(
                                          new Error(
                                            "ICD Code is required when specialty or description is provided!"
                                          )
                                        );
                                      }
                                    }

                                    // If this is the first ICD and no other ICDs are filled, require at least this one
                                    if (icd.id === 1) {
                                      const allValues = form.getFieldsValue();
                                      const hasAnyOtherICD = icdForms
                                        .slice(1)
                                        .some(
                                          (c) =>
                                            allValues[`icd_${c.id}_code`] ||
                                            allValues[
                                              `icd_${c.id}_specialty`
                                            ] ||
                                            allValues[`icd_${c.id}_description`]
                                        );

                                      if (
                                        !hasAnyOtherICD &&
                                        !value &&
                                        !specialty &&
                                        !description
                                      ) {
                                        return Promise.reject(
                                          new Error(
                                            "At least one ICD Code is required!"
                                          )
                                        );
                                      }
                                    }

                                    return Promise.resolve();
                                  },
                                }),
                              ]}
                              style={{ marginBottom: "0" }}
                            >
                              <Input
                                placeholder="Enter ICD Code"
                                size="small"
                              />
                            </Form.Item>
                          </Col>

                          {/* <Col span={8}>
                            <Form.Item
                              name={`cpt_${cpt.id}_specialty`}
                              rules={[
                                ({ getFieldValue }) => ({
                                  validator(_, value) {
                                    if (activeTab !== "individual") {
                                      return Promise.resolve();
                                    }

                                    const code = getFieldValue(
                                      `cpt_${cpt.id}_code`
                                    );
                                    const description = getFieldValue(
                                      `cpt_${cpt.id}_description`
                                    );

                                    // If any field is filled, all fields are required for this CPT
                                    if (code || description) {
                                      if (!value) {
                                        return Promise.reject(
                                          new Error(
                                            "Specialty is required when code or description is provided!"
                                          )
                                        );
                                      }
                                    }

                                    return Promise.resolve();
                                  },
                                }),
                              ]}
                              style={{ marginBottom: "0" }}
                            >
                              <Select
                                getPopupContainer={(triggerNode) =>
                                  triggerNode.parentNode
                                }
                                placeholder="Select Specialty"
                                showSearch
                                size="small"
                                style={{ width: "100%" }}
                                dropdownStyle={{
                                  maxHeight: 200,
                                  overflowY: "auto",
                                  overflowX: "hidden",
                                }}
                                listHeight={160}
                                options={specialtyOptions}
                                loading={loading}
                                filterOption={(input, option) =>
                                  (option?.label ?? "")
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                              />
                            </Form.Item>
                          </Col> */}

                          <Col span={14}>
                            <Form.Item
                              name={`icd_${icd.id}_description`}
                              rules={[
                                ({ getFieldValue }) => ({
                                  validator(_, value) {
                                    if (activeTab !== "individual") {
                                      return Promise.resolve();
                                    }

                                    const code = getFieldValue(
                                      `icd_${icd.id}_code`
                                    );
                                    const specialty = getFieldValue(
                                      `icd_${icd.id}_specialty`
                                    );

                                    // If any field is filled, all fields are required for this ICD
                                    if (code || specialty) {
                                      if (!value) {
                                        return Promise.reject(
                                          new Error(
                                            "Description is required when code or specialty is provided!"
                                          )
                                        );
                                      }
                                    }

                                    return Promise.resolve();
                                  },
                                }),
                              ]}
                              style={{ marginBottom: "0" }}
                            >
                              <Input
                                placeholder="Enter Description"
                                size="small"
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      </div>
                    ))}
                  </div>
                </div>
              </IndividualSection>
            </SectionContainer>

            <SectionContainer show={activeTab === "file-upload"}>
              <GroupSection>
                {/* File Upload Section */}
                <div style={{ marginBottom: "20px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                      marginBottom: "8px",
                    }}
                  >
                    <div>
                      <Typography.Text
                        strong
                        style={{
                          color: "var(--primary-text-color)",
                          marginBottom: "8px",
                          display: "block",
                        }}
                      >
                        Upload ICD Codes File
                      </Typography.Text>
                      <Typography.Text
                        style={{
                          color: "var(--secondary-text-color)",
                          marginBottom: "16px",
                          display: "block",
                          fontSize: "13px",
                        }}
                      >
                        {isPreviewMode
                          ? "Review the data below. ICD codes with red background already exist - please update their code or remove them."
                          : "Upload a CSV or Excel file containing ICD code details for bulk creation."}
                      </Typography.Text>
                    </div>
                  </div>

                  {!isPreviewMode && (
                    <>
                      <SampleFileContainer>
                        <Typography.Text className="sample-text">
                          Download our sample template to get started.
                        </Typography.Text>
                        <span
                          className="download-link"
                          onClick={downloadSampleFile}
                        >
                          <DownloadOutlined />
                          Download Sample
                        </span>
                      </SampleFileContainer>

                      <Row gutter={[24, 16]}>
                        <Col span={24}>
                          <Form.Item
                            name="icdFile"
                            label="Upload ICD Code Details"
                            extra="Supported formats: CSV, XLSX, XLS. Maximum file size: 10MB."
                          >
                            <Upload {...uploadProps} accept=".csv,.xlsx,.xls">
                              <Button
                                icon={<UploadOutlined />}
                                size="large"
                                block
                                className="text-primary"
                              >
                                Click to Upload File
                              </Button>
                            </Upload>
                          </Form.Item>
                        </Col>
                      </Row>
                    </>
                  )}

                  {isPreviewMode && previewData.length > 0 && (
                    <div style={{ marginBottom: "20px" }}>
                      {/* Sticky Header */}
                      <div
                        style={{
                          position: "sticky",
                          top: "0",
                          zIndex: 10,
                          background: "var(--secondary-bg)",
                          border: "1px solid var(--border-color)",
                          borderRadius: "4px 4px 0 0",
                          padding: "8px",
                          marginBottom: "0",
                        }}
                      >
                        <Row gutter={[8, 0]} align="middle">
                          <Col span={1}>
                            <div
                              style={{
                                fontSize: "13px",
                                fontWeight: "600",
                                color: "var(--primary-text-color)",
                                textAlign: "center",
                              }}
                            >
                              #
                            </div>
                          </Col>
                          <Col span={8}>
                            <div
                              style={{
                                fontSize: "13px",
                                fontWeight: "600",
                                color: "var(--primary-text-color)",
                              }}
                            >
                              ICD Code
                            </div>
                          </Col>
                          {/* <Col span={8}>
                            <div
                              style={{
                                fontSize: "13px",
                                fontWeight: "600",
                                color: "var(--primary-text-color)",
                              }}
                            >
                              Specialty
                            </div>
                          </Col> */}
                          <Col span={14}>
                            <div
                              style={{
                                fontSize: "13px",
                                fontWeight: "600",
                                color: "var(--primary-text-color)",
                              }}
                            >
                              Description
                            </div>
                          </Col>
                          <Col span={1}>
                            <div
                              style={{
                                fontSize: "13px",
                                fontWeight: "600",
                                color: "var(--primary-text-color)",
                                textAlign: "center",
                              }}
                            ></div>
                          </Col>
                        </Row>
                      </div>

                      {/* Preview Data Rows */}
                      <div
                        style={{
                          maxHeight: "400px",
                          overflowY: "auto",
                          border: "1px solid var(--border-color)",
                          borderTop: "none",
                          borderRadius: "0 0 4px 4px",
                        }}
                      >
                        {previewData.map((icd, index) => (
                          <div
                            key={icd.id}
                            style={{
                              padding: "8px",
                              borderBottom:
                                index < previewData.length - 1
                                  ? "1px solid var(--border-color)"
                                  : "none",
                              background: icd.alreadyExists
                                ? "#fee"
                                : "var(--primary-bg)",
                              "&:hover": {
                                background: icd.alreadyExists
                                  ? "#fdd"
                                  : "var(--secondary-bg)",
                              },
                            }}
                          >
                            <Row gutter={[8, 0]} align="middle">
                              <Col span={1}>
                                <div
                                  style={{
                                    fontSize: "13px",
                                    fontWeight: "500",
                                    color: "var(--secondary-text-color)",
                                    textAlign: "center",
                                  }}
                                >
                                  {index + 1}
                                </div>
                              </Col>

                              <Col span={8}>
                                <Input
                                  size="small"
                                  value={icd.code}
                                  onChange={(e) => {
                                    const newData = [...previewData];
                                    newData[index].code = e.target.value;
                                    newData[index].alreadyExists = false; // Reset exists status when code changes
                                    setPreviewData(newData);
                                  }}
                                  style={{
                                    border: icd.alreadyExists
                                      ? "1px solid #ff4d4f"
                                      : "1px solid var(--border-color)",
                                  }}
                                />
                              </Col>

                              {/* <Col span={8}>
                                <Select
                                  size="small"
                                  value={cpt.specialty}
                                  onChange={(value) => {
                                    const newData = [...previewData];
                                    newData[index].specialty = value;
                                    setPreviewData(newData);
                                  }}
                                  style={{ width: "100%" }}
                                  options={specialtyOptions}
                                  showSearch
                                  filterOption={(input, option) =>
                                    (option?.label ?? "")
                                      .toLowerCase()
                                      .includes(input.toLowerCase())
                                  }
                                />
                              </Col> */}

                              <Col span={14}>
                                <Input
                                  size="small"
                                  value={icd.description}
                                  onChange={(e) => {
                                    const newData = [...previewData];
                                    newData[index].description = e.target.value;
                                    newData[index].alreadyExists = false; // Reset exists status when description changes
                                    setPreviewData(newData);
                                  }}
                                  style={{
                                    border: icd.alreadyExists
                                      ? "1px solid #ff4d4f"
                                      : "1px solid var(--border-color)",
                                  }}
                                />
                              </Col>

                              <Col span={1}>
                                <div
                                  onClick={() => {
                                    const newData = previewData.filter(
                                      (_, i) => i !== index
                                    );
                                    setPreviewData(newData);
                                  }}
                                  style={{
                                    color: "#ff4d4f",
                                    cursor: "pointer",
                                    fontSize: "16px",
                                  }}
                                >
                                  <DeleteOutlined />
                                </div>
                              </Col>
                            </Row>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </GroupSection>
            </SectionContainer>
          </FormContainer>

          <Divider style={{ margin: "20px 0" }} />

          <Row>
            <Col span={24} className="d-flex justify-end gap-12">
              {isPreviewMode && (
                <CustomSecondaryButton
                  onClick={() => {
                    setIsPreviewMode(false);
                    setPreviewData([]);
                    setFileList([]);
                  }}
                >
                  Back to Upload
                </CustomSecondaryButton>
              )}
              <CustomSecondaryButton onClick={handleCancel}>
                Cancel
              </CustomSecondaryButton>
              <CustomButton htmlType="submit" loading={loading}>
                {loading
                  ? "Processing..."
                  : isPreviewMode
                  ? "Upload ICD Codes"
                  : "Add ICD Codes"}
              </CustomButton>
            </Col>
          </Row>
        </Form>
      </Spin>
    </ModalWrapper>
  );
};

// Edit ICD Code Modal Component
const EditICDModal = ({ visible, setVisible, onClose, onSuccess, icdData }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { specialtyOptions } = useContext(SpecilityContext);

  useEffect(() => {
    if (visible && icdData) {
      form.setFieldsValue({
        code: icdData.code,
        // specialty: icdData.specialty,
        description: icdData.description,
      });
    }
  }, [visible, icdData, form]);

  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      await icdCodesService.updateIcdCodes(icdData.id, values);
      notify("success", "ICD code updated successfully!");
      form.resetFields();
      setLoading(false);
      onSuccess();
      onClose();
    } catch (error) {
      notify("error", "Error updating ICD code.");
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <ModalWrapper
      title="Edit ICD Code"
      show={visible}
      setShow={setVisible}
      onCancel={handleCancel}
      footer={null}
      width={600}
      destroyOnClose
    >
      <Spin spinning={loading}>
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Form.Item
                name="code"
                label="ICD Code"
                rules={[
                  { required: true, message: "Please input the ICD code!" },
                ]}
              >
                <Input placeholder="Enter ICD Code" />
              </Form.Item>
            </Col>

            {/* <Col span={24}>
              <Form.Item
                name="specialty"
                label="Specialty"
                rules={[
                  { required: true, message: "Please select a specialty!" },
                ]}
              >
                <Select
                  placeholder="Select Specialty"
                  showSearch
                  style={{ width: "100%" }}
                  options={specialtyOptions}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                />
              </Form.Item>
            </Col> */}

            <Col span={24}>
              <Form.Item
                name="description"
                label="Description"
                rules={[
                  { required: true, message: "Please input description!" },
                ]}
              >
                <Input.TextArea placeholder="Enter Description" rows={3} />
              </Form.Item>
            </Col>
          </Row>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "12px",
              marginTop: "20px",
            }}
          >
            <Button style={{color: "var(--primary-text-color)"}} onClick={handleCancel}>Cancel</Button>
            <CustomButton htmlType="submit" loading={loading}>
              {loading ? "Updating..." : "Update ICD Code"}
            </CustomButton>
          </div>
        </Form>
      </Spin>
    </ModalWrapper>
  );
};

// Add Specialty Modal Component
const AddSpecialtyModal = ({ visible, setVisible, onClose, onSuccess }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [specialtyForms, setSpecialtyForms] = useState([{ id: 1 }]);
  const [nextId, setNextId] = useState(2);

  const handleSubmit = async (values) => {
    try {
      setLoading(true);

      // Create specialties array from form values
      const specialtiesToCreate = specialtyForms
        .map((specialty) => ({
          specialty: values[`specialty_${specialty.id}_name`],
        }))
        .filter((s) => s.specialty);

      if (specialtiesToCreate.length === 0) {
        notify("error", "Please fill in at least one specialty name.");
        setLoading(false);
        return;
      }

      await specialtyService.createSpecialties(specialtiesToCreate);
      notify(
        "success",
        `${specialtiesToCreate.length} specialties created successfully.`
      );

      handleCancel();
    } catch (error) {
      console.error("Error creating specialties:", error);
      notify("error", error?.data?.message || "Error creating specialties.");
      setLoading(false);
    }
  };

  const addSpecialtyField = () => {
    setSpecialtyForms([...specialtyForms, { id: nextId }]);
    setNextId(nextId + 1);
  };

  const removeSpecialtyField = (idToRemove) => {
    if (specialtyForms.length > 1) {
      setSpecialtyForms(
        specialtyForms.filter((field) => field.id !== idToRemove)
      );
      // Remove the form field value
      const fieldName = `specialty_${idToRemove}_name`;
      form.setFieldValue(fieldName, undefined);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    setSpecialtyForms([{ id: 1 }]);
    setNextId(2);
    setLoading(false);
    onSuccess();
    onClose();
  };

  return (
    <ModalWrapper
      title="Add Specialties"
      show={visible}
      setShow={setVisible}
      onCancel={handleCancel}
      footer={null}
      width={500}
      destroyOnClose
    >
      <Spin spinning={loading}>
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <FormContainer>
            <IndividualSection>
              <div
                className="section-title font-16 text-primary"
                style={{ fontWeight: 600 }}
              >
                Specialty Information
              </div>

              {/* Individual Specialty Forms - Row Style */}
              <div style={{ marginBottom: "20px" }}>
                {/* Sticky Header */}
                <div
                  style={{
                    position: "sticky",
                    top: "0",
                    zIndex: 10,
                    background: "var(--secondary-bg)",
                    border: "1px solid var(--border-color)",
                    borderRadius: "4px 4px 0 0",
                    padding: "8px",
                    marginBottom: "0",
                  }}
                >
                  <Row gutter={[8, 0]} align="middle">
                    <Col span={1}>
                      <div
                        style={{
                          fontSize: "13px",
                          fontWeight: "600",
                          color: "var(--primary-text-color)",
                          textAlign: "center",
                        }}
                      >
                        #
                      </div>
                    </Col>
                    <Col span={19}>
                      <div
                        style={{
                          fontSize: "13px",
                          fontWeight: "600",
                          color: "var(--primary-text-color)",
                        }}
                      >
                        Specialty Name
                      </div>
                    </Col>
                    <Col span={4}>
                      <div
                        style={{
                          fontSize: "13px",
                          fontWeight: "600",
                          color: "var(--primary-text-color)",
                          textAlign: "center",
                        }}
                      >
                        Actions
                      </div>
                    </Col>
                  </Row>
                </div>

                {/* Scrollable Rows */}
                <div
                  style={{
                    maxHeight: "300px",
                    overflowY: "auto",
                    border: "1px solid var(--border-color)",
                    borderTop: "none",
                    borderRadius: "0 0 4px 4px",
                  }}
                >
                  {specialtyForms.map((specialty, index) => (
                    <div
                      key={specialty.id}
                      style={{
                        padding: "8px",
                        borderBottom:
                          index < specialtyForms.length - 1
                            ? "1px solid var(--border-color)"
                            : "none",
                        background: "var(--primary-bg)",
                        "&:hover": { background: "var(--secondary-bg)" },
                      }}
                    >
                      <Row gutter={[8, 0]} align="middle">
                        <Col span={1}>
                          <div
                            style={{
                              fontSize: "13px",
                              fontWeight: "500",
                              color: "var(--secondary-text-color)",
                              textAlign: "center",
                            }}
                          >
                            {index + 1}
                          </div>
                        </Col>

                        <Col span={20}>
                          <Form.Item
                            name={`specialty_${specialty.id}_name`}
                            rules={[
                              ({ getFieldValue }) => ({
                                validator(_, value) {
                                  // Check if at least one specialty is filled across all fields
                                  const allValues = form.getFieldsValue();
                                  const hasAnySpecialty = specialtyForms.some(
                                    (s) => allValues[`specialty_${s.id}_name`]
                                  );

                                  // If no specialty is filled anywhere, require at least one
                                  if (!hasAnySpecialty && !value) {
                                    return Promise.reject(
                                      new Error(
                                        "At least one specialty is required!"
                                      )
                                    );
                                  }

                                  return Promise.resolve();
                                },
                              }),
                            ]}
                            style={{ marginBottom: "0" }}
                          >
                            <Input
                              placeholder="Enter Specialty Name"
                              size="small"
                            />
                          </Form.Item>
                        </Col>

                        <Col span={3}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              gap: "4px",
                            }}
                          >
                            {index === specialtyForms.length - 1 && (
                              <div
                                onClick={addSpecialtyField}
                                style={{
                                  fontSize: "14px",
                                  color: "#52c41a",
                                  cursor: "pointer",
                                  width: "24px",
                                  height: "24px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  borderRadius: "50%",
                                  transition: "all 0.3s ease",
                                  backgroundColor: "rgba(82, 196, 26, 0.1)",
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor =
                                    "rgba(82, 196, 26, 0.2)";
                                  e.currentTarget.style.transform =
                                    "scale(1.1)";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor =
                                    "rgba(82, 196, 26, 0.1)";
                                  e.currentTarget.style.transform = "scale(1)";
                                }}
                              >
                                <PlusOutlined />
                              </div>
                            )}
                            {specialtyForms.length > 1 &&
                              index !== specialtyForms.length - 1 && (
                                <div
                                  onClick={() =>
                                    removeSpecialtyField(specialty.id)
                                  }
                                  style={{
                                    fontSize: "14px",
                                    color: "#ff4d4f",
                                    cursor: "pointer",
                                    width: "24px",
                                    height: "24px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    borderRadius: "50%",
                                    transition: "all 0.3s ease",
                                    backgroundColor: "rgba(255, 77, 79, 0.1)",
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor =
                                      "rgba(255, 77, 79, 0.2)";
                                    e.currentTarget.style.transform =
                                      "scale(1.1)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor =
                                      "rgba(255, 77, 79, 0.1)";
                                    e.currentTarget.style.transform =
                                      "scale(1)";
                                  }}
                                >
                                  <DeleteOutlined />
                                </div>
                              )}
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ))}
                </div>
              </div>
            </IndividualSection>
          </FormContainer>

          <Divider style={{ margin: "20px 0" }} />

          <Row>
            <Col span={24} className="d-flex justify-end gap-12">
              <CustomSecondaryButton onClick={handleCancel}>
                Cancel
              </CustomSecondaryButton>
              <CustomButton htmlType="submit" loading={loading}>
                {loading ? "Creating..." : "Add Specialties"}
              </CustomButton>
            </Col>
          </Row>
        </Form>
      </Spin>
    </ModalWrapper>
  );
};

// Edit Specialty Modal Component
const EditSpecialtyModal = ({ visible, setVisible, onClose, onSuccess, specialtyData }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (visible && specialtyData) {
      form.setFieldsValue({
        specialty: specialtyData.specialty,
      });
    }
  }, [visible, specialtyData, form]);

  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      await specialtyService.updateSpecialty(specialtyData.id, values);
      notify("success", "Specialty updated successfully!");
      form.resetFields();
      setLoading(false);
      onSuccess();
      onClose();
    } catch (error) {
      notify("error", "Error updating specialty.");
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <ModalWrapper
      title="Edit Specialty"
      show={visible}
      setShow={setVisible}
      onCancel={handleCancel}
      footer={null}
      width={500}
      destroyOnClose
    >
      <Spin spinning={loading}>
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Form.Item
                name="specialty"
                label="Specialty Name"
                rules={[
                  {
                    required: true,
                    message: "Please input the specialty name!",
                  },
                  {
                    min: 2,
                    message: "Specialty name must be at least 2 characters!",
                  },
                  {
                    max: 100,
                    message: "Specialty name cannot exceed 100 characters!",
                  },
                ]}
              >
                <Input placeholder="Enter Specialty Name" autoFocus />
              </Form.Item>
            </Col>
          </Row>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "12px",
              marginTop: "20px",
            }}
          >
            <CustomSecondaryButton onClick={handleCancel}>
              Cancel
            </CustomSecondaryButton>
            <CustomButton htmlType="submit" loading={loading}>
              {loading ? "Updating..." : "Update Specialty"}
            </CustomButton>
          </div>
        </Form>
      </Spin>
    </ModalWrapper>
  );
};

const PasswordStrengthIndicator = ({ value }) => {
  const getColorAndLabel = () => {
    if (value <= 25) return { color: "#ff4d4f", label: "Weak" };
    if (value <= 50) return { color: "#faad14", label: "Fair" };
    if (value <= 75) return { color: "#1890ff", label: "Good" };
    return { color: "#52c41a", label: "Strong" };
  };

  const { color, label } = getColorAndLabel();

  return (
    <>
      <Progress
        percent={value}
        showInfo={false}
        strokeColor={color}
        steps={4}
        style={{ width: "100%" }}
      />
      <div className="d-flex justify-end">
        <Text className="font-12 font-medium" style={{ color }}>
          {label}
        </Text>
      </div>
    </>
  );
};

const PasswordRequirement = ({ met, text }) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      marginBottom: 10,
      color: met ? "#52c41a" : "rgba(0, 0, 0, 0.45)",
    }}
  >
    <div
      style={{
        width: 16,
        height: 16,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginRight: 8,
      }}
    >
      {met ? (
        <CheckOutlined style={{ fontSize: 15, color: "#52c41a" }} />
      ) : (
        <CloseOutlined style={{ fontSize: 14, color: "gray" }} />
      )}
    </div>
    <Text
      style={{
        fontSize: 16,
        color: met
          ? "var(--primary-text-color)"
          : "var(--secondary-text-color)",
        transition: "color 0.3s",
      }}
    >
      {text}
    </Text>
  </div>
);

const MyProfilePage = () => {
  const [myData, setMyData] = useState([]);
  const [isEditUser, setIsEditUser] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingMyData, setLoadingMyData] = useState(false);
  const [cptLoading, setCptLoading] = useState(false);
  const [cptCodes, setCptCodes] = useState([]);
  const [cptModalVisible, setCptModalVisible] = useState(false);
  const [editCptModalVisible, setEditCptModalVisible] = useState(false);
  const [selectedCptCode, setSelectedCptCode] = useState(null);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [icdLoading, setIcdLoading] = useState(false);
  const [icdCodes, setIcdCodes] = useState([]);
  const [icdModalVisible, setIcdModalVisible] = useState(false);
  const [editIcdModalVisible, setEditIcdModalVisible] = useState(false);
  const [selectedIcdCode, setSelectedIcdCode] = useState(null);
  const [icdCount, setIcdCount] = useState(0);
  const [icdSearchText, setIcdSearchText] = useState("");
  const [icdPagination, setIcdPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });
  const [deleteIcdModalVisible, setDeleteIcdModalVisible] = useState(false);
  const [deleteIcdLoading, setDeleteIcdLoading] = useState(false);

  // Specialty states
  const [specialtyLoading, setSpecialtyLoading] = useState(false);
  const [specialties, setSpecialties] = useState([]);
  const [filteredSpecialties, setFilteredSpecialties] = useState([]);
  const [specialtyModalVisible, setSpecialtyModalVisible] = useState(false);
  const [editSpecialtyModalVisible, setEditSpecialtyModalVisible] =
    useState(false);
  const [selectedSpecialty, setSelectedSpecialty] = useState(null);
  const [deleteSpecialtyModalVisible, setDeleteSpecialtyModalVisible] =
    useState(false);
  const [deleteSpecialtyLoading, setDeleteSpecialtyLoading] = useState(false);
  const [specialtySearchText, setSpecialtySearchText] = useState("");
  
  // CPT codes search states
  const [filteredCptCodes, setFilteredCptCodes] = useState([]);
  const [cptSearchText, setCptSearchText] = useState("");
  const [matchStatus, setMatchStatus] = useState({
    status: "",
    message: "",
  });
  const [requirements, setRequirements] = useState({
    length: false,
    uppercase: false,
    number: false,
    special: false,
  });
  const [passwordStrength, setPasswordStrength] = useState(0);
  const [formValues, setFormValues] = useState({
    cpassword: "",
    password: "",
    vpassword: "",
  });
  const [cptPagination, setCptPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });
  const [specialtyPagination, setSpecialtyPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });
  const [cptCount, setCptCount] = useState(0);
  const [specialtyCount, setSpecialtyCount] = useState(0);
  const [countryName, setCountryName] = useState('');
  const [zip, setZip] = useState('');
  const [message, setMessage] = useState('');
  const [zipData, setZipData] = useState(null);
  const [zipLoading, setZipLoading] = useState(false);

  const [form] = Form.useForm();
  const user = extractToken();

  const myProfile = async () => {
    try {
      setLoadingMyData(true);
      const res = await physicianService.getMyProfile();
      setMyData(res?.data);
      setLoadingMyData(false);
    } catch (error) {
      setLoadingMyData(false);
    }
  };

  const fetchCPTCodes = async (searchInput=cptSearchText) => {
    try {
      setCptLoading(true);
      const res = await cptCodesService.getCptCodesList(
        cptPagination.pageSize,
        cptPagination.current,
        searchInput
      );
      const cptData = res?.data?.results || [];
      setCptCodes(cptData);
      setFilteredCptCodes(cptData);
      setCptCount(res?.data?.totalResults);
      setCptLoading(false);
    } catch (error) {
      setCptLoading(false);
      notify("error", "Error fetching CPT codes.");
    }
  };

  const fetchICDCodes = async (searchInput=icdSearchText) => {
    try {
      setIcdLoading(true);
      const res = await icdCodesService.getIcdCodesList(
        icdPagination.pageSize,
        icdPagination.current,
        searchInput
      );
      const icdData = res?.data?.results || [];
      setIcdCodes(icdData);
      // setFilteredIcdCodes(icdData);
      setIcdCount(res?.data?.totalResults);
      setIcdLoading(false);
    } catch (error) {
      setIcdLoading(false);
      notify("error", "Error fetching ICD codes.");
    }
  };

  useEffect(() => {
    fetchICDCodes();
  }, [icdPagination]);

  const handleEditCpt = (record) => {
    setSelectedCptCode(record);
    setEditCptModalVisible(true);
  };

  const handleDeleteCpt = (record) => {
    setSelectedCptCode(record);
    setDeleteModalVisible(true);
  };

  const handleEditIcd = (record) => {
    setSelectedIcdCode(record);
    setEditIcdModalVisible(true);
  };

  const handleDeleteIcd = (record) => {
    setSelectedIcdCode(record);
    setDeleteIcdModalVisible(true);
  };

  const confirmDeleteCpt = async () => {
    try {
      setDeleteLoading(true);
      await cptCodesService.deleteCode({ ids: [selectedCptCode.id] });
      notify("success", "CPT code deleted successfully!");
      setDeleteLoading(false);
      setDeleteModalVisible(false);
      setSelectedCptCode(null);
      fetchCPTCodes();
    } catch (error) {
      notify("error", "Error deleting CPT code.");
      setDeleteLoading(false);
    }
  };

  const confirmDeleteIcd = async () => {
    try {
      setDeleteIcdLoading(true);
      await icdCodesService.deleteIcdCodes({ ids: [selectedIcdCode.id] });
      notify("success", "ICD code deleted successfully!");
      setDeleteIcdLoading(false);
      setDeleteIcdModalVisible(false);
      setSelectedIcdCode(null);
      fetchICDCodes();
    } catch (error) {
      notify("error", "Error deleting ICD code.");
      setDeleteIcdLoading(false);
    }
  };

  // Specialty functions
  const fetchSpecialties = async () => {
    try {
      setSpecialtyLoading(true);
      const res = await specialtyService.getSpecialtiesList(
        specialtyPagination.pageSize,
        specialtyPagination.current,
      );
      const specialtyData = res?.data?.results || [];
      setSpecialties(specialtyData);
      setFilteredSpecialties(specialtyData);
      setSpecialtyCount(res?.data?.totalResults);
      setSpecialtyLoading(false);
    } catch (error) {
      setSpecialtyLoading(false);
      notify("error", "Error fetching specialties.");
    }
  };

  const handleEditSpecialty = (record) => {
    setSelectedSpecialty(record);
    setEditSpecialtyModalVisible(true);
  };

  const handleDeleteSpecialty = (record) => {
    setSelectedSpecialty(record);
    setDeleteSpecialtyModalVisible(true);
  };

  const confirmDeleteSpecialty = async () => {
    try {
      setDeleteSpecialtyLoading(true);
      await specialtyService.deleteSpecialty({ ids: [selectedSpecialty.id] });
      notify("success", "Specialty deleted successfully!");
      setDeleteSpecialtyLoading(false);
      setDeleteSpecialtyModalVisible(false);
      setSelectedSpecialty(null);
      fetchSpecialties();
    } catch (error) {
      notify("error", "Error deleting specialty.");
      setDeleteSpecialtyLoading(false);
    }
  };

  const handleSpecialtySearch = (value) => {
    setSpecialtySearchText(value);
    if (!value) {
      setFilteredSpecialties(specialties);
    } else {
      const filtered = specialties.filter((specialty) =>
        specialty.specialty?.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredSpecialties(filtered);
    }
  };

  const handleCptSearch = useCallback(
    debounce((value) => {
      fetchCPTCodes(value, true);
    }, 500),
    []
    // setCptSearchText(value);
    // if (!value) {
    //   setFilteredCptCodes(cptCodes);
    // } else {
    //   const filtered = cptCodes.filter((cpt) =>
    //     cpt.code?.toLowerCase().includes(value.toLowerCase()) ||
    //     cpt.specialty?.toLowerCase().includes(value.toLowerCase()) ||
    //     cpt.description?.toLowerCase().includes(value.toLowerCase())
    //   );
    //   setFilteredCptCodes(filtered);
    // }
  );

  const handleIcdSearch = useCallback(
    debounce((value) => {
      fetchICDCodes(value, true);
    }, 500),
    []
  );

  const validateForm = () => {
    const newErrors = {};

    if (!formValues.cpassword) {
      notify("error", "Please enter a current password!");
      return;
    }
    // Validate password
    if (!formValues.password) {
      notify("error", "Please enter a new password!");
      return;
    } else if (formValues.password.length < 8) {
      notify("error", "Password must be at least 8 characters!");
      return;
    } else if (passwordStrength < 75) {
      notify("error", "Password is not strong enough!");
      return;
    } else if (formValues.cpassword === formValues.password) {
      notify("error", "New password cannot be same as current password!");
      return;
    }

    // Validate confirm password
    if (!formValues.vpassword) {
      notify("error", "Please confirm your password!");
      return;
    } else if (formValues.password !== formValues.vpassword) {
      notify("error", "Passwords do not match!");
      return;
    }

    return true;
  };

  const onChangePassword = async () => {
    if (validateForm()) {
      try {
        setLoading(true);
        const res = await auth.changePassword({
          oldPassword: formValues?.cpassword,
          newPassword: formValues?.password,
        });
        myProfile();
        setFormValues({
          ...formValues,
          cpassword: "",
          password: "",
          vpassword: "",
        });
        setRequirements({
          length: false,
          uppercase: false,
          number: false,
          special: false,
        });
        setMatchStatus({
          status: "",
          message: "",
        });
        setPasswordStrength(0);
        notify("success", "Password Changed Successfully!");
        setLoading(false);
      } catch (error) {
        notify("error", error?.data?.message);
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchCPTCodes();
  }, [cptPagination]);
  

  useEffect(() => {
    myProfile();
    fetchSpecialties();
  }, [specialtyPagination]);


  const handleChange = (value) => {
    const password = formValues?.password;
    const confirm = value;

    if (!confirm) {
      setMatchStatus({ status: "", message: "" });
    } else if (password === confirm) {
      setMatchStatus({
        status: "success",
        message: "Passwords match!",
      });
    } else {
      setMatchStatus({
        status: "error",
        message: "Passwords do not match.",
      });
    }
  };

  const checkPasswordStrength = (password) => {
    let strength = 0;
    let reqs = {
      length: password.length >= 8,
      uppercase: /[A-Z]/.test(password),
      number: /[0-9]/.test(password),
      special: /[^A-Za-z0-9]/.test(password),
    };

    setRequirements(reqs);

    if (reqs.length) strength += 25;
    if (reqs.uppercase) strength += 25;
    if (reqs.number) strength += 25;
    if (reqs.special) strength += 25;

    return strength;
  };

  const ChangeInputField = (field, value) => {
    setFormValues({
      ...formValues,
      [field]: value,
    });

    if (field === "password") {
      setPasswordStrength(checkPasswordStrength(value));
    }

    if (field === "vpassword") {
      handleChange(value);
    }
  };

  const cptColumns = [
    {
      title: "CPT Code",
      dataIndex: "code",
      key: "code",
      width: 100,
    },
    // {
    //   title: "Specialty",
    //   dataIndex: "specialty",
    //   key: "specialty",
    //   width: 150,
    // },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      width: 200,
      ellipsis: true,
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 150,
      render: (data) => data ? moment(data).format("DD MMM YYYY hh:mm A") : "-",
    },
    {
      title: "Updated At",
      dataIndex: "updatedAt",
      key: "updatedAt",
      width: 150,
      render: (data) => data ? moment(data).format("DD MMM YYYY hh:mm A") : "-",
    },
    {
      title: "Actions",
      key: "actions",
      width: 100,
      render: (_, record) => (
        <div style={{ display: "flex", gap: "8px" }}>
         
          <Tooltip title="Edit CPT Code">
            <div onClick={() => handleEditCpt(record)} className="icon-button-edit">
              <EditOutlined />
            </div>
          </Tooltip>
          <Tooltip title="Delete CPT Code">
            <div onClick={() => handleDeleteCpt(record)} className="icon-button-delete">
              <DeleteOutlined />
            </div>
          </Tooltip>
         
        </div>
      ),
    },
  ];

  const icdColumns = [
    {
      title: "ICD Code",
      dataIndex: "code",
      key: "code",
      width: 100,
    },
    // {
    //   title: "Specialty",
    //   dataIndex: "specialty",
    //   key: "specialty",
    //   width: 150,
    // },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      width: 200,
      ellipsis: true,
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 150,
      render: (data) => data ? moment(data).format("DD MMM YYYY hh:mm A") : "-",
    },
    {
      title: "Updated At",
      dataIndex: "updatedAt",
      key: "updatedAt",
      width: 150,
      render: (data) => data ? moment(data).format("DD MMM YYYY hh:mm A") : "-",
    },
    {
      title: "Actions",
      key: "actions",
      width: 100,
      render: (_, record) => (
        <div style={{ display: "flex", gap: "8px" }}>
         
          <Tooltip title="Edit ICD Code">
            <div 
              onClick={() => handleEditIcd(record)} 
              className="icon-button-edit"
            >
              <EditOutlined />
            </div>
          </Tooltip>
          <Tooltip title="Delete ICD Code">
            <div 
              onClick={() => handleDeleteIcd(record)} 
              className="icon-button-delete"
            >
              <DeleteOutlined />
            </div>
          </Tooltip>
         
        </div>
      ),
    },
  ];

  const specialtyColumns = [
    {
      title: "Name",
      dataIndex: "specialty",
      key: "specialty",
      width: 200,
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 150,
      render: (text) => moment(text).format("DD MMM YYYY"),
    },
    {
      title: "Updated At",
      dataIndex: "updatedAt",
      key: "updatedAt",
      width: 150,
      render: (text) => moment(text).format("DD MMM YYYY"),
    },
    {
      title: "Actions",
      key: "actions",
      width: 100,
      render: (_, record) => (
        <div style={{ display: "flex", gap: "8px" }}>
          <Tooltip title="Edit Specialty">
            <div
              onClick={() => handleEditSpecialty(record)}
              className="icon-button-edit"
            >
              <EditOutlined />
            </div>
          </Tooltip>

          <Tooltip title="Delete Specialty">
            <div
              onClick={() => handleDeleteSpecialty(record)}
              className="icon-button-delete"
            >
              <DeleteOutlined />
            </div>
          </Tooltip>
        </div>
      ),
    },
  ];

  const updateMyProfile = async (id, payload) => {
    const finalPayload = {
      ...payload,
      zip: zip,
      ...(zipData && {timeZone: zipData}),
    }
    try {
      const response = await physicianService.updateMyProfile(id, finalPayload);
      if (response.status === 200) {
        myProfile();
        setIsEditUser(false);
        notify("success", "Profile updated successfully");
      }
    } catch (error) {
      notify("error", error.message);
    }
  };

  const handleZipChange = (e) => {
    const value = e.target.value;
    setZip(value);
    if (value.length >= 3) {
      validateDebounced(value, countryName);
    } else {
      setMessage('');
      setZipData(null);
    }
  };

  const validateDebounced = useCallback(
    debounce(async (zipVal, countryCodeVal) => {
      setZipLoading(true);
      try {
        const msg = await validateZipCode(zipVal, countryCodeVal);
        setMessage(msg.message);
        setZipData(msg.data);
      } catch (err) {
        setMessage('Error validating ZIP');
        setZipLoading(false)
      } finally {
        setZipLoading(false)
      }
    }, 600),
    []
  );

  useEffect(() => {
    if(myData){
    setCountryName(myData?.country)
    setZip(myData?.zip)
    }
  }, [myData])
  

  const cptData = cptCodes.length;


  return (
    <>
      <ProfilePageWrapper>
        <Row className="custom-header w-100 mb-15">
          <Col className="header-item">
            <CustomTitle>My Profile</CustomTitle>
            <CustomSubTitle>
              View and update your personal details.
            </CustomSubTitle>
          </Col>
        </Row>
        <Row className="w-100">
          <Col
            span={24}
            className="d-flex justify-start profile-container mb-15"
          >
            { loadingMyData ? (
              <>
                <Skeleton.Avatar active size={70} shape="circle" style={{ marginRight: 16 }} />
                <Skeleton active title paragraph={{ rows: 1, width: [120, 200] }} />
              </>
            ) : (
              <Col className="d-flex gap-12">
                <div>
                  <Avatar
                    size={70}
                    style={{
                      backgroundColor: "var(--primary-bg)",
                      color: "var(--primary-text-color)",
                    }}
                  >
                    {capitalizeFirstLetter(myData?.name?.charAt(0))}
                  </Avatar>
                </div>
                <div className="row-flex justify-content-center flex-column">
                  <span
                    className="d-flex justify-start font-20 font-semibold text-primary"
                    style={{ gap: "5px" }}
                  >
                    {capitalizeFirstLetter(myData?.name)}
                    {myData?.boardMember && (
                      <span>
                        <Tag className="cursor board-member-tag">
                          Board Member
                        </Tag>
                      </span>
                    )}
                  </span>
                  <span
                    className="font-medium text-secondry"
                    style={{ fontSize: "13px" }}
                  >
                    {capitalizeFirstLetter(myData?.email)}
                  </span>
                  <div className="d-flex justify-start gap-12">
                    <span
                      className="font-medium text-secondry"
                      style={{ fontSize: "13px" }}
                    >
                      Role: {capitalizeFirstLetter(myData?.role === globalRoles.OWNER ? globalRoles.PHYSICIAN:myData?.role)}
                    </span>
                    {(myData?.role === globalRoles.PHYSICIAN || myData?.role === globalRoles.ASSISTANT ||
                      myData?.role === globalRoles.OWNER
                    ) && (
                      <> 
                        <span><Divider type="vertical" style={{ backgroundColor: "#893EF4", margin: "0 1px" }} /></span>
                        <span
                          className="font-medium text-secondry"
                          style={{ fontSize: "13px" }}
                        >
                          Specialty: {myData?.specialty ? capitalizeFirstLetter(myData.specialty) : "N/A"}
                        </span>
                      </>
                    )}
                  </div>
                </div>
              </Col>
            )}
          </Col>

          <Col span={24} className="mb-15">
            <PersonalInfoWrapper>
              <Form form={form} style={{ height: "100%" }} onFinish={updateMyProfile}>
                <div className="cardHeader">
                  <div className="d-flex justify-start">
                    <div
                      className="d-flex align-start w-100"
                      style={{ justifyContent: "space-between" }}
                    >
                      <div className="heading">Summary</div>
                      <div style={{ paddingRight: "30px" }}>
                        {!isEditUser ? (
                          <div
                            className="cursor"
                            onClick={() => setIsEditUser(!isEditUser)}
                          >
                            <BiSolidPencil color="#8a3ef4" size={20} />
                          </div>
                        ) : (
                          <>
                            <Button
                              style={{
                                background: "none",
                                border: "none",
                                color: "var(--primary-text-color)",
                                width: 0,
                                height: 0,
                                marginRight: "20px",
                              }}
                              onClick={() => setIsEditUser(!isEditUser)}
                              className="font-bold"
                            >
                              Cancel
                            </Button>
                            <Button
                              style={{
                                background: "none",
                                border: "none",
                                color: "var(--primary-text-color)",
                                width: 0,
                                height: 0,
                              }}
                              onClick={()=> updateMyProfile(myData?.id, form.getFieldsValue())}
                              className="font-bold mx-4"
                            >
                              Save
                            </Button>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="cardContainer">
                  <Row gutter={[24, 24]}>
                    <Col span={6}>
                      <div className="subHeading">First Name</div>
                      {isEditUser ? (
                        <Form.Item
                          style={{ marginBottom: 10 }}
                          className="username"
                          name="name"
                          initialValue={myData?.name}
                          rules={[
                            {
                              required: true,
                              message: "firstname is required!",
                            },
                          ]}
                        >
                          <Input placeholder="Firstname" />
                        </Form.Item>
                      ) : (
                        <div className="data">{myData?.name}</div>
                      )}
                    </Col>

                    <Col span={6}>
                      <div className="subHeading">City</div>
                      {isEditUser ? (
                        <Form.Item
                          style={{ marginBottom: 10 }}
                          name="city"
                          initialValue={myData?.city ? myData?.city : ""}
                          rules={[
                            {
                              required: true,
                              message: "city is required!",
                            },
                          ]}
                        >
                          <Input placeholder="City" />
                        </Form.Item>
                      ) : (
                        <div className="data">
                          {myData?.city ? myData?.city : "N/A"}
                        </div>
                      )}
                    </Col>

                    <Col span={6}>
                      <div className="subHeading">State</div>
                      {isEditUser ? (
                        <Form.Item
                          style={{ marginBottom: 10 }}
                          name="state"
                          initialValue={myData?.state ? myData?.state : ""}
                          rules={[
                            {
                              required: true,
                              message: "state is required!",
                            },
                          ]}
                        >
                          <Input placeholder="State" />
                        </Form.Item>
                      ) : (
                        <div className="data">
                          {myData?.state ? myData?.state : "N/A"}
                        </div>
                      )}
                    </Col>

                    <Col span={6}>
                      <div className="subHeading">Country</div>
                      {isEditUser ? (
                        <Form.Item
                          style={{ marginBottom: 10 }}
                          name="country"
                          initialValue={myData?.country}
                          rules={[
                            {
                              required: true,
                              message: "country is required!",
                            },
                          ]}
                        >
                          <Select
                            style={{ width: '100%' }}
                            showSearch
                            placeholder="Select Country"
                            dropdownStyle={{ maxHeight: 200, overflowY: 'auto', overflowX: 'hidden' }}
                            listHeight={160}
                            value={countryName}
                            onChange={(value)=> setCountryName(value)}
                            optionLabelProp="label"
                            filterOption={(input, option) =>
                              option?.label.toLowerCase().includes(input.toLowerCase())
                            }
                          >
                            {limitedcountry.map((country) => (
                              <Option
                                value={country.code}
                                label={country.name}
                              >
                                <span>{country.name}</span>
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      ) : (
                        <div className="data">
                          {myData?.country ? myData?.country : "N/A"}
                        </div>
                      )}
                    </Col>

                    {(user?.role === globalRoles.SUPERADMIN ||
                     user?.role === globalRoles.PHYSICIAN ||
                     user?.role === globalRoles.ASSISTANT ||
                     user?.role === globalRoles.OWNER) && (
                     <Col span={6}>
                      <div className="subHeading">Zip Code</div>
                      {isEditUser ? (
                        <Form.Item
                          style={{ marginBottom: 10 }}
                          name="zip"
                          rules={[
                            {
                              required: true,
                              message: "zip is required!",
                            },
                          ]}
                        >
                          <Input 
                            type="text"
                            placeholder="e.g., 560034"
                            value={zip}
                            onChange={handleZipChange}
                          />
                          {zipLoading ? (
                             <Spin indicator={<LoadingOutlined spin />} className="customZipSpin"/>
                            ):(<span className="customZipSpin font-12 text-primary">{zipData && zipData}</span>)}
                          {message && (
                            <p className="m-0" style={{color: zipData?"green":"red", fontSize: "13px" }}>{message}</p>
                          )}
                        </Form.Item>
                      ) : (
                        <div className="data">
                          {myData?.zip ? myData?.zip : "N/A"}
                        </div>
                      )}
                    </Col>
                     )}

                    <Col span={6}>
                      <div className="subHeading">Email</div>
                      <div className="data ellipsis">{myData?.email}</div>
                    </Col>

                    <Col span={6}>
                      <div className="subHeading">Member since</div>
                      <div className="data">
                        {moment(myData?.createdAt).format("DD MMM YYYY")}
                      </div>
                    </Col>

                    <Col span={6}>
                      <div className="subHeading">2FA Active</div>
                      <div className="data ellipsis">
                        {myData?.is2FaActive === true ? "Enabled" : "Disabled"}
                      </div>
                    </Col>
                    {/* {myData?.role === globalRoles.PHYSICIAN && (
                      <Col span={6}>
                        <div className="subHeading">Specialty</div>
                        <div className="data ellipsis">
                          {myData?.specialty ? myData.specialty : "N/A"}
                        </div>
                      </Col>
                    )} */}
                  </Row>
                </div>
              </Form>
            </PersonalInfoWrapper>
          </Col>

          <Col span={24} className="mb-15">
            <PersonalInfoWrapper>
              <div className="cardHeader">
                <div className="d-flex justify-start">
                  <div
                    className="d-flex align-start w-100"
                    style={{ justifyContent: "space-between" }}
                  >
                    <div className="heading">Change Password</div>
                    <div className="subHeading px-3">
                      Last Update :{" "}
                      {moment_ori(myData?.updatedAt).format("DD-MM-YYYY")}
                    </div>
                  </div>
                </div>
              </div>

              <div className="cardContainer">
                <Form form={form} onFinish={onChangePassword} layout="vertical">
                  <Row gutter={[24, 0]}>
                    <Col span={12} className="row-flex flex-column">
                      <Col>
                        <Form.Item
                          className="username"
                          label="Current Password"
                          rules={[
                            {
                              required: true,
                              message: "Please input your current password!",
                            },
                          ]}
                        >
                          <Input.Password
                            placeholder="Current Password"
                            value={formValues?.cpassword}
                            onChange={(e) =>
                              ChangeInputField("cpassword", e.target.value)
                            }
                            iconRender={(visible) =>
                              visible ? (
                                <EyeOutlined
                                  style={{
                                    fontSize: "100%",
                                  }}
                                />
                              ) : (
                                <EyeInvisibleOutlined
                                  style={{
                                    fontSize: "100%",
                                  }}
                                />
                              )
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col>
                        <Form.Item
                          className="username"
                          label="New Password"
                          rules={[
                            {
                              required: true,
                              message: "Please input your new password!",
                            },
                            {
                              validator: (_, value) => {
                                if (!value || checkStrongPassword(value)) {
                                  return Promise.resolve();
                                }
                                return Promise.reject();
                              },
                            },
                          ]}
                        >
                          <Input.Password
                            placeholder="New Password"
                            value={formValues?.password}
                            onChange={(e) =>
                              ChangeInputField("password", e.target.value)
                            }
                            iconRender={(visible) =>
                              visible ? (
                                <EyeOutlined
                                  style={{
                                    fontSize: "100%",
                                    marginRight: "3px",
                                  }}
                                />
                              ) : (
                                <EyeInvisibleOutlined
                                  style={{
                                    fontSize: "100%",
                                    marginRight: "3px",
                                  }}
                                />
                              )
                            }
                            type="password"
                          />
                          {passwordStrength || passwordStrength?.length > 0 ? (
                            <PasswordStrengthIndicator
                              value={passwordStrength}
                            />
                          ) : undefined}
                        </Form.Item>
                      </Col>
                      <Col>
                        <Form.Item
                          className="username"
                          label="Confirm New Password"
                          validateStatus={matchStatus.status}
                          help={
                            matchStatus.status === "success" ? (
                              <span style={{ color: "green" }}>
                                {matchStatus.message}
                              </span>
                            ) : (
                              <span style={{ color: "red" }}>
                                {matchStatus.message}
                              </span>
                            )
                          }
                          rules={[
                            {
                              required: true,
                              message: "Please confirm your password!",
                            },
                            ({ getFieldValue }) => ({
                              validator(_, value) {
                                if (
                                  !value ||
                                  getFieldValue("password") === value
                                ) {
                                  return Promise.resolve();
                                }
                                return Promise.reject(
                                  new Error(
                                    "Passwords do not match. Please try again."
                                  )
                                );
                              },
                            }),
                          ]}
                        >
                          <Input.Password
                            placeholder="Confirm New Password"
                            value={formValues?.vpassword}
                            onChange={(e) =>
                              ChangeInputField("vpassword", e.target.value)
                            }
                            iconRender={(visible) =>
                              visible ? (
                                <EyeOutlined
                                  style={{
                                    fontSize: "100%",
                                    marginRight: "3px",
                                  }}
                                />
                              ) : (
                                <EyeInvisibleOutlined
                                  style={{
                                    fontSize: "100%",
                                    marginRight: "3px",
                                  }}
                                />
                              )
                            }
                            type="password"
                          />
                        </Form.Item>
                      </Col>
                      <Col className="d-flex justify-content-center mt-5">
                        <CustomButton htmlType="submit">Update</CustomButton>
                      </Col>
                    </Col>
                    <Col span={12} className="d-flex justify-content-center">
                      <div
                        style={{
                          borderRadius: 8,
                          height: "270px",
                        }}
                      >
                        <Text
                          className="text-primary font-17"
                          style={{
                            display: "block",
                            marginBottom: 12,
                            fontWeight: 600,
                          }}
                        >
                          <SafetyOutlined style={{ marginRight: 8 }} />
                          Password must contain:
                        </Text>

                        <PasswordRequirement
                          met={requirements.length}
                          text="At least 8 characters"
                        />
                        <PasswordRequirement
                          met={requirements.uppercase}
                          text="At least 1 uppercase letter (A-Z)"
                        />
                        <PasswordRequirement
                          met={requirements.number}
                          text="At least 1 number (0-9)"
                        />
                        <PasswordRequirement
                          met={requirements.special}
                          text="At least 1 special character (!@#$%^&*)"
                        />
                      </div>
                    </Col>
                  </Row>
                </Form>
              </div>
            </PersonalInfoWrapper>
          </Col>

          {/* CPT Codes Section */}
          {(user?.role === globalRoles.SUPERADMIN || user?.role === globalRoles.LIBRARY_MANAGER) && (
          <Col span={24} className="mb-15">
            <PersonalInfoWrapper>
              <div className="cardHeader">
                <div className="d-flex justify-start">
                  <div
                    className="d-flex align-start w-100"
                    style={{ justifyContent: "space-between" }}
                  >
                    <div className="heading">CPT Codes</div>
                    <div style={{ paddingRight: "30px" }}>
                      <CustomButton
                        onClick={() => setCptModalVisible(true)}
                        icon={<PlusOutlined />}
                      >
                        Add CPT Codes
                      </CustomButton>
                    </div>
                  </div>
                </div>
              </div>

              <div className="cardContainer">
                <div className="d-flex justify-end" style={{ marginBottom: '16px' }}>
                  {/* <CustomSearchContainer> */}
                    <Input
                      className="search-bar"
                      placeholder="Search CPT codes by code, specialty, or description..."
                      prefix={
                        <CiSearch
                          size={18}
                          style={{ color: "var(--primary-text-color)" }}
                        />
                      }
                      onChange={(e) => {
                        setCptSearchText(e.target.value);
                        handleCptSearch(e.target.value);
                      }}
                      value={cptSearchText}
                      style={{ width: '400px' }}
                    />
                  {/* </CustomSearchContainer> */}
                </div>
                <StyledTable
                  columns={cptColumns}
                  dataSource={filteredCptCodes.map((code) => ({
                    ...code,
                    specialty: code.specialty || "-",
                  }))}
                  loading={cptLoading}
                  scroll={cptCodes.length > 0 ? { y: '-webkit-fill-available', x: true } : null}
                  rowKey="id"
                  pagination={{
                    current: cptPagination?.current,
                    pageSize: cptPagination?.pageSize,
                    showSizeChanger: true,
                    pageSizeOptions: [25, 50, 100],
                    onShowSizeChange: (current, size) => {
                      setCptPagination({
                        ...cptPagination,
                        current,
                        pageSize: size,
                      });
                    },
                    total: cptCount,
                    showTotal: (total, range) =>
                      `${range[0]} - ${range[1]} of ${total} CPT codes`,
                    showQuickJumper: false,
                    showLessItems: true,
                    itemRender: (page, type, originalElement) => {
                      if (type === "prev") {
                        return (
                          <Button
                            type="text"
                            disabled={cptPagination?.current === 1}
                            onClick={(e) => {
                              e.stopPropagation();
                              if (cptPagination?.current > 1) {
                                setCptPagination((prev) => ({ 
                                  ...prev,
                                  current: prev.current - 1,
                                }));
                              }
                            }}
                          >
                            Previous
                          </Button>
                        );
                      }
                      if (type === "next") {
                        const maxPage = Math.ceil(cptCount / cptPagination?.pageSize);
                        return (
                          <Button
                            type="text"
                            disabled={cptPagination?.current === maxPage}
                            onClick={(e) => {
                              e.stopPropagation();
                              if (cptPagination?.current < maxPage) {
                                setCptPagination((prev) => ({
                                  ...prev,
                                  current: prev.current + 1,
                                }));
                              }
                            }}
                          >
                            Next
                          </Button>
                        );
                      }
                      return originalElement;
                    },
                  }}
                  // scroll={{ y: `calc(100vh - 330px)`, x: true }}
                />
              </div>
            </PersonalInfoWrapper>
          </Col>
          )}

          {/* Specialties Section */}
          {(user?.role === globalRoles.SUPERADMIN || user?.role === globalRoles.LIBRARY_MANAGER) && (
          <Col span={24} className="mb-15">
            <PersonalInfoWrapper>
              <div className="cardHeader">
                <div className="d-flex justify-start">
                  <div
                    className="d-flex align-start w-100"
                    style={{ justifyContent: "space-between" }}
                  >
                    <div className="heading">Specialties</div>
                    <div style={{ paddingRight: "30px" }}>
                      <CustomButton
                        onClick={() => setSpecialtyModalVisible(true)}
                        icon={<PlusOutlined />}
                      >
                        Add Specialty
                      </CustomButton>
                    </div>
                  </div>
                </div>
              </div>

              <div className="cardContainer">
                <div
                  className="d-flex justify-end"
                  style={{ marginBottom: "16px" }}
                >
                  {/* <CustomSearchContainer> */}
                    <Input
                      className="search-bar"
                      placeholder="Search specialties by name..."
                      prefix={
                        <CiSearch
                          size={18}
                          style={{ color: "var(--primary-text-color)" }}
                        />
                      }
                      onChange={(e) => {
                        setSpecialtySearchText(e.target.value);
                        handleSpecialtySearch(e.target.value);
                      }}
                      value={specialtySearchText}
                      style={{ width: '366px' }}
                    />
                  {/* </CustomSearchContainer> */}
                </div>
                <StyledTable
                  columns={specialtyColumns}
                  dataSource={filteredSpecialties}
                  loading={specialtyLoading}
                  rowKey="id"
                  scroll={filteredSpecialties.length > 0 ? { y: '-webkit-fill-available', x: true } : null}
                  pagination={{
                    current: specialtyPagination?.current,
                    pageSize: specialtyPagination?.pageSize,
                    showSizeChanger: true,
                    pageSizeOptions: [25, 50, 100],
                    onShowSizeChange: (current, size) => {
                      setSpecialtyPagination({
                        ...specialtyPagination,
                        current,
                        pageSize: size,
                      });
                    },
                    total: specialtyCount,
                    showTotal: (total, range) =>
                      `${range[0]} - ${range[1]} of ${total} specialties`,
                    showQuickJumper: false,
                    showLessItems: true,
                    itemRender: (page, type, originalElement) => {
                      if (type === "prev") {
                        return (
                          <Button
                            type="text"
                            disabled={specialtyPagination?.current === 1}
                            onClick={(e) => {
                              e.stopPropagation();
                              if (specialtyPagination?.current > 1) {
                                setSpecialtyPagination((prev) => ({ 
                                  ...prev,
                                  current: prev.current - 1,
                                }));
                              }
                            }}
                          >
                            Previous
                          </Button>
                        );
                      }
                      if (type === "next") {
                        const maxPage = Math.ceil(specialtyCount / specialtyPagination?.pageSize);
                        return (
                          <Button
                            type="text"
                            disabled={specialtyPagination?.current === maxPage}
                            onClick={(e) => {
                              e.stopPropagation();
                              if (specialtyPagination?.current < maxPage) {
                                setSpecialtyPagination((prev) => ({
                                  ...prev,
                                  current: prev.current + 1,
                                }));
                              }
                            }}
                          >
                            Next
                          </Button>
                        );
                      }
                      return originalElement;
                    },
                  }}
                  // scroll={{ x: 600 }}
                />
              </div>
            </PersonalInfoWrapper>
          </Col>
          )}

          {/* ICD Codes Section */}
          {(user?.role === globalRoles.SUPERADMIN || user?.role === globalRoles.LIBRARY_MANAGER) && (
          <Col span={24}>
            <PersonalInfoWrapper>
              <div className="cardHeader">
                <div className="d-flex justify-start">
                  <div
                    className="d-flex align-start w-100"
                    style={{ justifyContent: "space-between" }}
                  >
                    <div className="heading">ICD Codes</div>
                    <div style={{ paddingRight: "30px" }}>
                      <CustomButton
                        onClick={() => setIcdModalVisible(true)}
                        icon={<PlusOutlined />}
                      >
                        Add ICD Codes
                      </CustomButton>
                    </div>
                  </div>
                </div>
              </div>

              <div className="cardContainer">
                <div className="d-flex justify-end" style={{ marginBottom: '16px' }}>
                  {/* <CustomSearchContainer> */}
                    <Input
                      className="search-bar"
                      placeholder="Search ICD codes by code, specialty, or description..."
                      prefix={
                        <CiSearch
                          size={18}
                          style={{ color: "var(--primary-text-color)" }}
                        />
                      }
                      onChange={(e) => {
                        setIcdSearchText(e.target.value);
                        handleIcdSearch(e.target.value);
                      }}
                      value={icdSearchText}
                      style={{ width: '400px' }}
                    />
                  {/* </CustomSearchContainer> */}
                </div>
                <StyledTable
                  columns={icdColumns}
                  dataSource={icdCodes.map((code) => ({
                    ...code,
                    specialty: code.specialty || "-",
                  }))}
                  loading={icdLoading}
                  scroll={icdCodes.length > 0 ? { y: '-webkit-fill-available', x: true } : null}
                  rowKey="id"
                  pagination={{
                    current: icdPagination?.current,
                    pageSize: icdPagination?.pageSize,
                    showSizeChanger: true,
                    pageSizeOptions: [25, 50, 100],
                    onShowSizeChange: (current, size) => {
                      setIcdPagination({
                        ...icdPagination,
                        current,
                        pageSize: size,
                      });
                    },
                    total: icdCount,
                    showTotal: (total, range) =>
                      `${range[0]} - ${range[1]} of ${total} ICD codes`,
                    showQuickJumper: false,
                    showLessItems: true,
                    itemRender: (page, type, originalElement) => {
                      if (type === "prev") {
                        return (
                          <Button
                            type="text"
                            disabled={icdPagination?.current === 1}
                            onClick={(e) => {
                              e.stopPropagation();
                              if (icdPagination?.current > 1) {
                                setIcdPagination((prev) => ({ 
                                  ...prev,
                                  current: prev.current - 1,
                                }));
                              }
                            }}
                          >
                            Previous
                          </Button>
                        );
                      }
                      if (type === "next") {
                        const maxPage = Math.ceil(icdCount / icdPagination?.pageSize);
                        return (
                          <Button
                            type="text"
                            disabled={icdPagination?.current === maxPage}
                            onClick={(e) => {
                              e.stopPropagation();
                              if (icdPagination?.current < maxPage) {
                                setIcdPagination((prev) => ({
                                  ...prev,
                                  current: prev.current + 1,
                                }));
                              }
                            }}
                          >
                            Next
                          </Button>
                        );
                      }
                      return originalElement;
                    },
                  }}
                  // scroll={{ y: `calc(100vh - 330px)`, x: true }}
                />
              </div>
            </PersonalInfoWrapper>
          </Col>
          )}
        </Row>

        {/* CPT Modal */}
        {cptModalVisible && (
          <AddCPTModal
            visible={cptModalVisible}
            setVisible={setCptModalVisible}
            onClose={() => setCptModalVisible(false)}
            onSuccess={fetchCPTCodes}
          />
        )}

        {/* ICD Modal */}
        {icdModalVisible && (
          <AddICDModal 
            visible={icdModalVisible}
            setVisible={setIcdModalVisible}
            onClose={() => setIcdModalVisible(false)}
            onSuccess={fetchICDCodes}
          />
        )}

        {editIcdModalVisible && (
          <EditICDModal 
            visible={editIcdModalVisible}
            setVisible={setEditIcdModalVisible}
            onClose={() => {
              setEditIcdModalVisible(false);
              setSelectedIcdCode(null);
            }}
            onSuccess={fetchICDCodes}
            icdData={selectedIcdCode}
          />
        )}

        {/* Edit CPT Modal */}
        {editCptModalVisible && (
          <EditCPTModal
            visible={editCptModalVisible}
            setVisible={setEditCptModalVisible}
            onClose={() => {
              setEditCptModalVisible(false);
              setSelectedCptCode(null);
            }}
            onSuccess={fetchCPTCodes}
            cptData={selectedCptCode}
          />
        )}

        {/* Delete Confirmation Modal */}
        {deleteModalVisible && (
          <DeleteConfirmationModal
            isOpen={deleteModalVisible}
            setOpen={setDeleteModalVisible}
            onConfiem={confirmDeleteCpt}
            loading={deleteLoading}
            title="Delete CPT Code"
            message={`Are you sure you want to delete CPT code "${selectedCptCode?.code}"?`}
          />
        )}

        {/* Delete ICD Confirmation Modal */}
        {deleteIcdModalVisible && (
          <DeleteConfirmationModal
            isOpen={deleteIcdModalVisible}
            setOpen={setDeleteIcdModalVisible}
            onConfiem={confirmDeleteIcd}
            loading={deleteIcdLoading}
            title="Delete ICD Code"
            message={`Are you sure you want to delete ICD code "${selectedIcdCode?.code}"?`}
          />
        )}

        {/* Specialty Modals */}
        {specialtyModalVisible && (
          <AddSpecialtyModal
            visible={specialtyModalVisible}
            setVisible={setSpecialtyModalVisible}
            onClose={() => setSpecialtyModalVisible(false)}
            onSuccess={fetchSpecialties}
          />
        )}

        {editSpecialtyModalVisible && (
          <EditSpecialtyModal
            visible={editSpecialtyModalVisible}
            setVisible={setEditSpecialtyModalVisible}
            onClose={() => {
              setEditSpecialtyModalVisible(false);
              setSelectedSpecialty(null);
            }}
            onSuccess={fetchSpecialties}
            specialtyData={selectedSpecialty}
          />
        )}

        {deleteSpecialtyModalVisible && (
          <DeleteConfirmationModal
            isOpen={deleteSpecialtyModalVisible}
            setOpen={setDeleteSpecialtyModalVisible}
            onConfiem={confirmDeleteSpecialty}
            loading={deleteSpecialtyLoading}
            title="Delete Specialty"
            message={`Are you sure you want to delete specialty "${selectedSpecialty?.specialty}"?`}
          />
        )}
      </ProfilePageWrapper>
    </>
  );
};

export default MyProfilePage;
